import type { MediaImage, Metaobject, Video as VideoType } from "@shopify/hydrogen-react/storefront-api-types";
import React, { useMemo } from "react";

import Video from "../atoms/Video";

import Image from "@atoms/Image";
import Link from "@atoms/Link";

interface IProps {
  node: Metaobject;
}

const GRID_RATIO = { width: 1080, height: 1350 };

export default function HomeCard({ node }: IProps) {
  const data = useMemo(() => {
    const imageContent = node?.fields.find((item) => item.key === "content")?.reference as MediaImage;
    const videoContent = node?.fields.find((item) => item.key === "content")?.reference as VideoType;
    const link = node?.fields.find((item) => item.key === "link")?.value || "/";
    const title = node?.fields.find((item) => item.key === "title")?.value || "";
    const description = node?.fields.find((item) => item.key === "description")?.value || "";

    return {
      link,
      imageContent,
      videoContent,
      title,
      description,
    };
  }, [node]);

  return (
    <Link className="flex! flex-col gap-2 self-start" href={data.link}>
      {data.imageContent.mediaContentType === "IMAGE" && (
        <Image
          alt={data.imageContent.image?.altText || ""}
          className="w-full"
          height={GRID_RATIO.height}
          src={data.imageContent.image?.url || ""}
          width={GRID_RATIO.width}
        />
      )}

      {data.imageContent.mediaContentType === "VIDEO" && (
        <Video
          className="w-full object-cover"
          height={GRID_RATIO.height}
          src={data.videoContent.sources[1]?.url || ""}
          width={GRID_RATIO.width}
        />
      )}

      <div className="flex flex-col gap-0.5">
        <span>{data.title}</span>
        <span className="font-normal">{data.description}</span>
      </div>
    </Link>
  );
}
